import Api from './Api'

export default {
  create(dados) {
    return Api().post('/events/register', dados)
  },
  
  get(keyword = '', pageNumber = 1, sortBy = 'data', myEvents = false) {
    return Api().get('/events/my', {
      params: { keyword, pageNumber, sortBy, myEvents }
    })
  },
  
  getOne(id) {
    return Api().get(`/events/${id}`)
  },
  
  getStateTotal() {
    return Api().get(`events/eventosPorEstado`);
  },

  update(dados) {
    return Api().put(`/events/${dados.id}`, dados)
  },
  
  imagesPos(formData){
    const config = {
        headers: {
          'Content-Type': 'multipart/form-data', // Indica que estamos enviando FormData
        },
      };
  
    return Api().post(`events/registerPosEvent`, formData, config);
},
  
  getTotal() {
    return Api().get('/events/total')
  },
  
  getEventsByState(state, pageNumber) {
    return Api().get(`events/byStates?state=${state}&pageNumber=${pageNumber}`);
  },

  getEventImagePreviousPeriod() {
    return Api().get(`events/galeria/periodo-anterior`);
  },
}